module.exports = __webpack_public_path__ + "static/img/bg_daoshigeren@2x.d2be1f75.png";